import { generateClasses } from '@formkit/themes'
import theme from './formtheme.js'

export default {
  config: {
    classes: generateClasses(theme)
  }
}
